export class RMDClientFavouriteCarriersModel {
  favouriteId: number;
  clientId: number;
  carrierId: number;
  business_name: string;
  isFavourite: boolean;
}